{
  "statusOptions": {
    "all": "ทั้งหมด",
    "unpaired": "กำลังลงรายการ",
    "paired": "กำลังชำระเงิน",
    "paymentMade": "รอปล่อยเหรียญ",
    "completed": "ธุรกรรมเสร็จสิ้น",
    "canceling": "กำลังยกเลิก",
    "canceled": "ยกเลิกธุรกรรม",
    "forceCanceled": "ยกเลิกธุรกรรม",
    "complainted": "กำลังแก้ไข",
    "appealing": "กำลังอุทธรณ์"
  },
  "tags": {
    "buy": {
      "all": "ทั้งหมด",
      "unpaired": "กำลังลงรายการ",
      "paired": "กำลังชำระเงิน",
      "paymentMade": "รอผู้ขายปล่อยเหรียญ",
      "completed": "ธุรกรรมเสร็จสิ้น",
      "canceling": "ผู้ขายกำลังยกเลิก",
      "canceled": "ยกเลิกธุรกรรม",
      "forceCanceled": "ยกเลิกธุรกรรม",
      "complainted": "กำลังแก้ไข",
      "appealing": "กำลังอุทธรณ์"
    },
    "sell": {
      "all": "ทั้งหมด",
      "unpaired": "กำลังลงรายการ",
      "paired": "ผู้ซื้อกำลังชำระเงิน",
      "paymentMade": "รอปล่อยเหรียญ",
      "completed": "ธุรกรรมเสร็จสิ้น",
      "canceling": "กำลังยกเลิก",
      "requestCancel": "กำลังยกเลิก",
      "canceled": "ยกเลิกธุรกรรม",
      "forceCanceled": "ยกเลิกธุรกรรม",
      "complainted": "กำลังแก้ไข",
      "appealing": "กำลังอุทธรณ์"
    }
  },
  "fastTrack": {
    "all": "ทั้งหมด",
    "creating": "กำลังสร้าง",
    "awaitSettlement": "รอการชำระเงินเสร็จสิ้น",
    "adminResolving": "กำลังดำเนินการ",
    "completed": "ธุรกรรมเสร็จสิ้น",
    "failed": "ธุรกรรมล้มเหลว",
    "timedOut": "หมดเวลา"
  }
}
